import axios from 'axios'

const API_PATH = 'api/v2/admins/product_locations'

const ProductLocationsApiV2 = {
  get: async ({ q = '', type_name = '' } = {}) => {
    const params = {}
    if (q) params.q = q
    if (type_name) params.type_name = type_name

    const response = axios.get(API_PATH, { params })
    return response
  },

  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  create: async ({ name, type_name, active = true }) => {
    const payload = {
      name,
      type_name,
      active
    }

    const response = axios.post(API_PATH, payload)
    return response
  },

  update: async ({ id, name, type_name, active }) => {
    const path = `${API_PATH}/${id}`
    const payload = {
      name,
      type_name,
      active
    }

    const response = axios.patch(path, payload)
    return response
  }
}

export default ProductLocationsApiV2
